<template>
  <div class="etab-address-component">
    <!-- address -->
    <Field
      :ref="iModel.address"
      v-slot="{ errors, value, field }"
      v-model="_address"
      tag="div"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@ETAB_ADDRESS'))"
      :rules="{ required: true }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        :label="$t('ETAB.FORMS.LABELS.@ETAB_ADDRESS')"
        :name="iModel.address"
        type="text"
        :error="errors.length > 0"
        :error-message="errors[0]"
      />
    </Field>

    <div class="address-double-input">
      <!-- postalCode -->
      <Field
        :ref="iModel.postalCode"
        v-slot="{ errors, field, value }"
        v-model="_postalCode"
        class="q-mr-sm q-field"
        tag="div"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@ETAB_POSTAL_CODE'))"
        :rules="{ required: true, numeric: true, length: 5 }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.FORMS.LABELS.@ETAB_POSTAL_CODE')"
          :name="iModel.postalCode"
          type="number"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
      <!-- city -->
      <Field
        :ref="iModel.city"
        v-slot="{ errors, field, value }"
        v-model="_city"
        tag="div"
        class="q-field"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@ETAB_CITY'))"
        :rules="{ required: true }"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          :label="$t('ETAB.FORMS.LABELS.@ETAB_CITY')"
          :name="iModel.city"
          type="text"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
    </div>
  </div>
</template>

<script>
  import { Field } from "vee-validate";

  export default {
    components: {
      Field,
    },
    props: {
      address: { type: String, default: null },
      city: { type: String, default: null },
      postalCode: { type: String, default: null },
      iModel: { type: Object, default: () => ({}) },
    },
    emits: ["update:address", "update:city", "update:postalCode"],
    computed: {
      _address: {
        get() {
          return this.address;
        },
        set(value) {
          this.$emit("update:address", value);
        },
      },
      _city: {
        get() {
          return this.city;
        },
        set(value) {
          this.$emit("update:city", value);
        },
      },
      _postalCode: {
        get() {
          return this.postalCode;
        },
        set(value) {
          this.$emit("update:postalCode", value);
        },
      },
    },
  };
</script>

<style lang="scss">
  .etab-address-component {
    .address-double-input {
      display: flex;
      .q-field:nth-of-type(1) {
        flex: 2;
      }
      .q-field:nth-of-type(2) {
        flex: 3;
        margin-left: 20px;
      }
    }

    .q-field {
      margin-bottom: 24px;
    }
  }
</style>
